module.exports = __webpack_public_path__ + "media/images/menu/icn-profile-3bfc8850fafdb96db3d66d0ca3736fb1.svg";